import {FlexPage} from '@hconnect/common/components'
import {Grid, Stack} from '@mui/material'

type LayoutProps = Partial<{
  titleSlot: React.ReactNode
  headerActionsSlot: React.ReactNode
  kpisSlot: React.ReactNode
  trendSlot: React.ReactNode
  commentsSlot: React.ReactNode
}>

export const PerformanceReviewLayout = ({
  titleSlot,
  headerActionsSlot,
  kpisSlot,
  trendSlot,
  commentsSlot
}: LayoutProps) => {
  return (
    <FlexPage title={titleSlot} headerActionContent={headerActionsSlot} nameHeaderSx={{mt: 0}}>
      <Grid container spacing={2}>
        {kpisSlot && (
          <Grid item xs={12} md={6} lg={4}>
            {kpisSlot}
          </Grid>
        )}
        {trendSlot && (
          <Grid item xs={12} md={6} lg={8}>
            <Stack spacing={2}>
              {trendSlot}
              {commentsSlot}
            </Stack>
          </Grid>
        )}
      </Grid>
    </FlexPage>
  )
}
